import axios from "axios";
import { useState, useEffect } from "react";
import GetLatLngOnly from "../../../properties/components/shared/GetLatLngOnlyPure";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import localforage from "localforage";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ImagesUpload from "../../../properties/components/forms/ImagesUpload";

const dbName = "DataLead";
localforage.config({
  name: dbName,
  storeName: "Data_Lead_Asset",
  description: "Store(lat,lng,phone_number,description,images)",
});

const EditLead = () => {
  const [textCheckPhoneNumber, setTextCheckPhoneNumber] = useState("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");
  const navigate = useNavigate();

  const checkPhoneNumber = (number) => {
    const finalNumber = number.replace(/[^0-9-]/g, "").replace(/-/g, "");
    if (finalNumber.length > 10) {
      setTextCheckPhoneNumber("กรุณาระบุเบอร์โทรแค่ 10 หลัก");
    } else if (finalNumber.length === 10) {
      axios
        .get(`${process.env.REACT_APP_API}/event/checkExistedlead/${finalNumber}`)
        .then((res) => setTextCheckPhoneNumber(res.data.message))
        .catch(console.error);
    }
  };

  const [upload, setUpload] = useState({
    lat: null, lng: null, phone_number: "", description: "",
    images: [], asset_type: "house", type_post: ["ขาย"], removeimg: [""],
  });

  const [typeOfLead, setTypeOfLead] = useState(null);
  const [leadId, setLeadId] = useState(null);
  const [lengthOfDetailPost, setLengthOfDetailPost] = useState(0);
  const [isValidLocation, setIsValidLocation] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [assetLocationLatitude, setAssetLocationLatitude] = useState(null);
  const [assetLocationLongitude, setAssetLocationLongitude] = useState(null);

  const { lat, lng, phone_number, description, images, asset_type, type_post } = upload;

  const currentURL = window.location.href;
  const lead_id = currentURL.split("/").at(-1);

  useEffect(() => {
    const session_id = Cookies.get("jwt");
    axios
      .post(`${process.env.REACT_APP_API}/fetchdata/get-imperfect-lead`, { lead_id }, { headers: { Authorization: `Bearer ${session_id}` } })
      .then((res) => {
        const data = res.data;
        setTypeOfLead(data.type);
        setLeadId(data.id);
        setLengthOfDetailPost(data.description.length);
        setUpload({
          ...upload,
          phone_number: data.contact.PhoneNumber,
          description: data.description,
          asset_type: data.type,
          type_post: data.type_post.Type,
          lat: data.location.coordinates.lat,
          lng: data.location.coordinates.lng,
          images: data.images_url.AssetImagesURL,
        });
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    if (phone_number.length < 10) setTextCheckPhoneNumber("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");
  }, [phone_number]);

  useEffect(() => {
    setUpload((prev) => ({
      ...prev,
      lat: assetLocationLatitude?.asset_location_latitude ?? "",
      lng: assetLocationLongitude?.asset_location_longitude ?? "",
    }));
  }, [assetLocationLatitude, assetLocationLongitude]);

  const inputValue = (name) => (e) => setUpload({ ...upload, [name]: e.target.value });

  const handleDetailPostLimit = (e) => {
    if (e.target.value.length <= 999) {
      setLengthOfDetailPost(e.target.value.length);
      setUpload((prev) => ({ ...prev, description: e.target.value }));
    } else {
      Swal.fire({ icon: "error", title: "เกินจำนวนตัวอักษรที่กำหนด", text: "สูงสุด 999 ตัวอักษร", showConfirmButton: false, timer: 1500 });
    }
  };

  const getToken = () => Cookies.get("jwt");

  const handleUpdateLeadAsset = () => {
    setIsUploading(true);
    axios
      .post(`${process.env.REACT_APP_API}/update/editlead`,
        { lead_id, asset_type: upload.asset_type, type_post: upload.type_post, description: upload.description, phone_number: upload.phone_number, lat: upload.lat, lng: upload.lng, images: upload.images, removeimg: upload.removeimg },
        { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" } }
      )
      .then(async () => {
        setIsUploading(false);
        await Swal.fire("ส่งข้อมูลสำเร็จ", "รูปภาพอาจใช้เวลาอัปเดตสูงสุด 1 นาที", "success");
        window.location.replace("/profile/mylead");
      })
      .catch((err) => {
        setIsUploading(false);
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: `${err.response.data.Error}` });
      });
  };

  const handleDeleteLead = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/event/deleteAsset`, { asset_id: leadId }, { headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" } });
      Swal.fire({ icon: "success", title: "ลบสำเร็จ!", showConfirmButton: false, timer: 1500 });
    } catch (error) {
      Swal.fire({ icon: "error", title: "ลบไม่สำเร็จ", text: error.response?.data?.message || "Something went wrong" });
    }
  };

  function handleCheckboxValidLocation() {
    setIsValidLocation(!isValidLocation);
    if (isValidLocation && lat === null && lng === null) setUpload({ ...upload, lat: null, lng: null });
  }

  function handleWarningUser(typeOfLead) {
    Swal.fire({
      title: "คำเตือน",
      text: "การแก้ไข Lead อย่างละเอียดเมื่อแก้ไขเสร็จสิ้นจะทำให้ Lead ของคุณถูกย้ายไปที่ประกาศของฉัน!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34BFD9",
      cancelButtonColor: "#000",
      confirmButtonText: "ดำเนินการต่อ",
    }).then((result) => {
      if (result.isConfirmed) {
        const typeMap = { house: "/house", condo: "/condo", land: "/land", commercial: "/commercial", townhouse: "/townhouse" };
        navigate(`/edit${typeMap[typeOfLead] || ""}/${leadId}`);
      }
    });
  }

  const listTypeAssets = [
    { label: "บ้านเดี่ยว", key: "house" },
    { label: "คอนโด", key: "condo" },
    { label: "ทาวน์เฮ้าส์", key: "townhouse" },
    { label: "ที่ดิน", key: "land" },
    { label: "อาคารพาณิชย์", key: "commercial" },
    { label: "โกดัง/โรงงาน", key: "other" },
  ];

  const listTypePost = [
    { label: "ขาย", key: "sell" },
    { label: "เช่า", key: "rent" },
    { label: "เซ้ง", key: "sell_out" },
  ];

  const phoneStatus = textCheckPhoneNumber === "เบอร์โทรนี้ไม่ได้เป็นสมาชิก สามารถส่งข้อมูลเข้ามาได้"
    ? "ok" : textCheckPhoneNumber === "กรุณากรอกเบอร์โทรศัพท์ 10 หลัก" ? "neutral" : "error";

  const inputCls = "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors";
  const labelCls = "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5";

  const [pageNumber, setPageNumber] = useState(1);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex items-center gap-3"
        >
          <button
            onClick={() => window.location.replace("/profile/mylead")}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">Lead ของฉัน</p>
            <h1 className="text-lg font-bold text-gray-900">แก้ไข Lead</h1>
          </div>
        </motion.div>

        {/* ── Phone number ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <div className="px-0 pb-0">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ข้อมูลการติดต่อ</p>
            <label className={labelCls}>เบอร์โทรศัพท์เจ้าของทรัพย์</label>
            <input
              type="text"
              inputMode="numeric"
              value={upload.phone_number}
              placeholder="0XX-XXX-XXXX"
              onChange={(e) => { inputValue("phone_number")(e); checkPhoneNumber(e.target.value); }}
              className={inputCls}
            />
            {phone_number.length > 0 && (
              <p className={`text-xs mt-1.5 font-medium ${phoneStatus === "ok" ? "text-emerald-600" : phoneStatus === "error" ? "text-red-500" : "text-gray-400"}`}>
                {textCheckPhoneNumber}
              </p>
            )}
          </div>
        </motion.div>

        {/* ── Images ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.06 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">รูปภาพ</p>
          <ImagesUpload
            images={upload.images}
            upload={upload}
            setUpload={setUpload}
            setPageNumber={setPageNumber}
          />
        </motion.div>

        {/* ── Location ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.08 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ตำแหน่งทรัพย์</p>
          <label className="flex items-center gap-2.5 cursor-pointer mb-4">
            <div
              className={`w-5 h-5 rounded flex items-center justify-center border-2 transition-colors ${isValidLocation ? "bg-blue-600 border-blue-600" : "border-gray-300 bg-white"}`}
              onClick={handleCheckboxValidLocation}
            >
              {isValidLocation && (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <span className="text-sm text-gray-600">ไม่มีตำแหน่ง / ไม่ทราบตำแหน่ง</span>
          </label>

          {!isValidLocation && (
            <div className="w-full h-[400px] rounded-xl overflow-hidden relative">
              <div className="w-8 h-8 absolute right-2 top-24 z-10 md:hidden bg-white rounded-full shadow flex items-center justify-center">
                <MdKeyboardArrowUp className="w-5 h-5" />
              </div>
              <div className="w-8 h-8 absolute right-2 bottom-24 z-10 md:hidden bg-white rounded-full shadow flex items-center justify-center">
                <MdKeyboardArrowDown className="w-5 h-5" />
              </div>
              <GetLatLngOnly
                setAssetLocationLatitude={setAssetLocationLatitude}
                setAssetLocationLongitude={setAssetLocationLongitude}
                latLeadDataUserClickBeforeExitPage={lat}
                lngLeadDataUserClickBeforeExitPage={lng}
              />
            </div>
          )}
        </motion.div>

        {/* ── Asset type ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ประเภทอสังหาฯ</p>
          <div className="grid grid-cols-3 gap-2">
            {listTypeAssets.map((data, idx) => (
              <button
                key={idx}
                onClick={() => setUpload({ ...upload, asset_type: data.key })}
                className={`py-2.5 text-sm font-semibold rounded-xl transition-colors ${data.key === asset_type ? "bg-blue-600 text-white" : "bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100"}`}
              >
                {data.label}
              </button>
            ))}
          </div>
        </motion.div>

        {/* ── Post type ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.12 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ประเภทการขาย</p>
          <div className="grid grid-cols-3 gap-2">
            {listTypePost.map((data, idx) => {
              const isSelected = type_post.includes(data.label);
              return (
                <button
                  key={idx}
                  onClick={() => {
                    setUpload({
                      ...upload,
                      type_post: isSelected
                        ? type_post.filter((t) => t !== data.label)
                        : [...type_post, data.label],
                    });
                  }}
                  className={`py-2.5 text-sm font-semibold rounded-xl transition-colors ${isSelected ? "bg-blue-600 text-white" : "bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100"}`}
                >
                  {data.label}
                </button>
              );
            })}
          </div>
        </motion.div>

        {/* ── Description ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.14 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <div className="flex items-center justify-between mb-3">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">รายละเอียด</p>
            <span className="text-xs text-gray-400 font-medium">{lengthOfDetailPost}/999</span>
          </div>
          <textarea
            value={description ?? ""}
            onChange={handleDetailPostLimit}
            placeholder="กรอกรายละเอียดทรัพย์..."
            className="w-full h-40 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors resize-none"
          />
        </motion.div>

        {/* ── Actions ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.16 }}
          className="space-y-2.5"
        >
          {/* Update */}
          <button
            onClick={handleUpdateLeadAsset}
            disabled={isUploading}
            className="w-full py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-70 flex items-center justify-center gap-2"
          >
            {isUploading ? (
              <>
                <svg className="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                กำลังอัปเดต...
              </>
            ) : "อัปเดตข้อมูล Lead"}
          </button>

          {/* Edit in detail */}
          <button
            onClick={() => handleWarningUser(typeOfLead)}
            className="w-full py-3.5 bg-gray-50 border border-gray-200 text-gray-700 text-sm font-semibold rounded-xl hover:bg-gray-100 transition-colors"
          >
            แก้ไขอย่างละเอียด
          </button>

          {/* Delete */}
          <button
            onClick={handleDeleteLead}
            className="w-full py-3.5 bg-red-50 border border-red-100 text-red-500 text-sm font-semibold rounded-xl hover:bg-red-100 transition-colors"
          >
            ลบประกาศ
          </button>
        </motion.div>

        <div className="h-8" />
      </div>
    </div>
  );
};

export default EditLead;
